import { X } from 'lucide-react';
import fields from '../fields';
import { activeFilters } from '../columnVisibility';

/**
 * The filters currently hiding rows, named and dismissable.
 *
 * EXTRACTED FROM MobileSheetView ON 2026-09-13, AND NOW ON DESKTOP TOO.
 *
 * The phone had this from the start and the desktop sheet had nothing: an active
 * filter showed as a small 🔍 inside one column header, and the only way to
 * clear it was to find that header and right-click it. Three ways that fails,
 * and the third is the one that forced this:
 *
 *   1. The column can be scrolled off the side of a wide sheet, so the only sign
 *      that rows are being withheld is off screen.
 *   2. The column can be HIDDEN, and then there is no sign at all. (Also fixed,
 *      separately and at the root — see columnVisibility.js.)
 *   3. The owner may not have set the filter. As of today a dashboard card can
 *      arrive here having set one, and "why am I only seeing nine of my forty
 *      cars" must have an answer on screen rather than in the release notes.
 *
 * ONE IMPLEMENTATION, TWO MOUNT POINTS. The mobile view renders it inside its
 * toolbar where its chips have always been; each sheet renders it above the
 * table with `hidden md:flex`. Two copies of this markup would drift, and the
 * mobile one is the one with the better behaviour to copy.
 *
 * IT MUST BE MOUNTED OUTSIDE THE SHEET'S SCROLL CONTAINER on desktop. That
 * container scrolls horizontally with the table, so chips placed inside it slide
 * off the side exactly like the column header they were meant to replace.
 */
export default function SheetFilterChips({ filterObject, filterData, className = '' }) {
  const active = activeFilters(filterObject);
  if (active.length === 0) return null;

  return (
    <div className={`msheet-chips ${className}`.trim()}>
      {active.map(([name, f]) => (
        <button
          key={name}
          type="button"
          className="msheet-chip"
          //`filterData(name)` with no filter type is how this codebase clears
          //one column — see filterDataUtility. It writes `{}` rather than
          //deleting the key, which is why `activeFilters` tests filterType
          //rather than truthiness.
          onClick={() => filterData(name)}
          title={`Remove the filter on ${fields[name]?.displayName || name}`}
        >
          <span className="msheet-chip-text">
            {fields[name]?.displayName || name} {f.filterType}{' '}
            {f.lowerValue}{f.filterType === 'between' ? ` – ${f.upperValue}` : ''}
          </span>
          <X size={13} aria-hidden="true" />
        </button>
      ))}
      {/* Offered from two filters up, because with one the chip beside it
          already clears everything and a second button doing the same thing
          reads as if it did something more. */}
      {active.length > 1 && (
        <button type="button" className="msheet-chip msheet-chip-clear" onClick={() => filterData('')}>
          Clear all
        </button>
      )}
    </div>
  );
}
